import { isEqual, uniq } from 'lodash';
import { Stack } from '@mui/material';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { FlowResourceType, useEditorStore } from '@diana/core';
import { StepNode } from './StepNode';
import { TaskNode } from './TaskNode';

export const FlowExplorer = () => {
  const stepIds = useEditorStore(
    (s) => uniq(s.flow?.steps.map((step) => step.stepId) ?? []),
    isEqual,
  );
  const firstStepId = useEditorStore((s) => s.flow?.steps[0]?.stepId ?? '');
  const firstTaskId = useEditorStore((s) => s.flow?.steps[0]?.taskId ?? '');
  const isAssetType = useEditorStore(
    (store) => store.flow?.properties.flowResourceType === FlowResourceType.Entity,
  );

  return (
    <DndProvider backend={HTML5Backend}>
      {isAssetType ? (
        <TaskNode
          taskId={firstTaskId}
          stepId={firstStepId}
          stepIndex={0}
          taskIndex={0}
          level={0}
          canDrag={false}
          isSingleTask
        />
      ) : (
        <Stack gap={0.25}>
          {stepIds.map((stepId, stepIndex) => (
            <StepNode
              key={stepId}
              stepId={stepId}
              stepIndex={stepIndex}
              canDrag={stepIds.length > 1}
            />
          ))}
        </Stack>
      )}
    </DndProvider>
  );
};
